var React = require('react');

function Coop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00deb2;}")),React.createElement("title",{"key":1},"Linked\r_account"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M13.21,0A8.19,8.19,0,0,0,5.49,5.47h2a6.36,6.36,0,1,1,.38,6.15l-1.8.57A8.2,8.2,0,1,0,13.21,0Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M8.2,23.88a8.19,8.19,0,0,0,7.72-5.48h-2a6.36,6.36,0,1,1-.39-6.14l1.8-.58A8.2,8.2,0,1,0,8.2,23.88Z","key":1})]))]);
}

Coop.defaultProps = {"viewBox":"0 0 21.41 23.88"};

module.exports = Coop;

Coop.default = Coop;
